import { Component, OnInit } from '@angular/core';
import { Activity } from '../../models/activity';
import { Exercise } from '../../models/exercise';
import { ExerciseService } from '../../services/exercise.service';
import { ActivityService } from '../../services/activity.service';
import { AssetsService } from '../../services/assets.service';
import EAssetTypes from '../../config/AssetsType';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit {

  public ErrorMsg: string;
  public editMode: boolean;

  public listOfExercises: Array<Exercise>;
  public listOfActivities: Array<Activity>;
  public listOfSongs: Array<any>;
  public exoToPush: any;

  public editingActivity: Activity;
  public exercisesToAdd: Array<any>;

  constructor(private activityService: ActivityService, private exerciseService: ExerciseService, private assetsService: AssetsService) { }

  ngOnInit() {
    this.editMode = false;
    this.ErrorMsg = '';
    this.editingActivity = new Activity();
    this.editingActivity.sequence = [];
    this.exercisesToAdd = [];
    this.listOfSongs = [];
    this.activityService.getAllActivities().then((activities) => {
      this.listOfActivities = activities;
      this.exerciseService.getAllExercises().then((exercises) => {
        this.listOfExercises = exercises;
      });
    });
    this.assetsService.getAllAssets().then((assets) => {
      assets.forEach(asset => {
        if (asset.type === EAssetTypes.AUDIO) {
          this.listOfSongs.push(asset);
        }
      });
    });

  }

  public addActivity() {
    this.exercisesToAdd.forEach((exo, index) => {
      this.editingActivity.sequence.push(exo._id);
    });

    if (this.editingActivity.name && this.editingActivity.sequence.length > 0) {
      this.activityService.addActivity(this.editingActivity)
        .subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name And Sequence Are Required.';
    }
  }

  public isExoSelected(exo) {
    if (this.editingActivity.sequence.indexOf(exo._id) === -1) {
      return false;
    } else {
      return true;
    }
  }

  public setActivityToEdit(activity) {
    this.editMode = true;
    this.editingActivity = activity;
    this.editingActivity.song = activity.song._id;
    this.exercisesToAdd = [];
    activity.sequence.forEach(exercise => {
      this.exercisesToAdd.push(exercise);
    });
  }

  public delActivity(id) {
    this.activityService.delActivity(id).subscribe(() => { this.ngOnInit(); });
  }

  public editActivity() {
    this.editingActivity.sequence = this.exercisesToAdd;
    if (this.editingActivity.name && this.editingActivity.sequence.length > 0) {
      this.activityService.editActivity(this.editingActivity)
        .subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name And Sequence Are Required.';
    }
  }

  public addExercise() {
    this.listOfExercises.forEach(exo => {
      if (this.exoToPush === exo._id) {
        this.exercisesToAdd.push(exo);
      }
    });
  }

  public removeExercise(index) {
    this.exercisesToAdd.splice(index, 1);
  }

  public quitEditingMode() {
    this.editMode = false;
    this.editingActivity = new Activity();
    this.exercisesToAdd = [];
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/activity/activity.component.ts